/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from "react";

const styles = {
  digitContainer: {
    // margin: "8px",
    height: "40px",
    width: "35px",
    border: "1px solid #707070",
    borderRadius: "10px",
    textAlign: "center",
    outline: "none",
  },
};

function OTPInput({ id, style }) {
  const handleKeyUp = (e, nextID) => {
    const keyId = e.keyCode;
    switch (keyId) {
      case 8:
        if (nextID - 2 <= 0) return;
        document.getElementById(`digit${nextID - 2}`).focus();
        break;
      default:
        if (nextID > 6) return;
        document.getElementById(`digit${nextID}`).focus();
        break;
    }
  };
  return (
    <input
      type="text"
      style={{ ...styles.digitContainer, ...style }}
      id={`digit${id}`}
      name={`otp-${id}`}
      placeholder="_"
      maxLength="1"
      onKeyUp={(e) => handleKeyUp(e, id + 1)}
    />
  );
}

export default OTPInput;
